import { render } from "./App.vue?vue&type=template&id=58d451a6&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__